import React from 'react';
import {
  TARIFF_REQUIRED_FIELDS, ALL_TARIFF_OPTIONAL_FIELDS,
  PRICE_COMPONENT_REQUIRED_FIELDS, ALL_PRICE_COMPONENT_OPTIONAL_FIELDS
} from '../config/tariffFields';

export default function TariffStepReview({
  organisationMode, organisationId, organisationName, organisations,
  formData, priceComponents, includeIdleFee, idleFee
}) {
  const orgDisplayName = organisationMode === 'existing'
    ? organisations.find(o => String(o.id) === String(organisationId))?.name
    : organisationName;

  const allTariffFields = [...TARIFF_REQUIRED_FIELDS, ...ALL_TARIFF_OPTIONAL_FIELDS];
  const allComponentFields = [...PRICE_COMPONENT_REQUIRED_FIELDS, ...ALL_PRICE_COMPONENT_OPTIONAL_FIELDS];

  return (
    <>
      <div className="review-block">
        <div className="review-block-title">Tariff Details</div>
        <div className="review-row">
          <span className="review-row-label">Organisation</span>
          <span className="review-row-value">{orgDisplayName || '—'}</span>
        </div>
        {allTariffFields.map(field => {
          const value = formData[field.name];
          if (!value) return null;
          return (
            <div className="review-row" key={field.name}>
              <span className="review-row-label">{field.label}</span>
              <span className="review-row-value">{value}</span>
            </div>
          );
        })}
      </div>

      {priceComponents.map((component, index) => (
        <div className="review-block" key={component.tempId}>
          <div className="review-block-title">Price Component {index + 1}</div>
          {allComponentFields.map(field => {
            const value = component.formData[field.name];
            if (!value) return null;
            return (
              <div className="review-row" key={field.name}>
                <span className="review-row-label">{field.label}</span>
                <span className="review-row-value">
                  {field.name === 'price_per_unit' ? `${formData.currency || ''} ${value}` : value}
                </span>
              </div>
            );
          })}
        </div>
      ))}

      {includeIdleFee && (idleFee.idle_time || idleFee.idle_price || idleFee.grace_period) && (
        <div className="review-block">
          <div className="review-block-title">Idle / Parking Fee</div>
          {idleFee.idle_time && (
            <div className="review-row">
              <span className="review-row-label">Idle Time</span>
              <span className="review-row-value">{idleFee.idle_time}</span>
            </div>
          )}
          {idleFee.idle_price && (
            <div className="review-row">
              <span className="review-row-label">Idle Price</span>
              <span className="review-row-value">{formData.currency} {idleFee.idle_price}</span>
            </div>
          )}
          {idleFee.grace_period && (
            <div className="review-row">
              <span className="review-row-label">Grace Period</span>
              <span className="review-row-value">{idleFee.grace_period}</span>
            </div>
          )}
        </div>
      )}
    </>
  );
}